import { useEffect } from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { notifications } from '@debbie/cortex/dist';
import * as updatesAPI from '@debbie/cortex/dist/api/updates';
import { selectCaseUpdates } from '@debbie/cortex/dist/case/selectors';
import { selectCaseById } from '@debbie/cortex/dist/cases/selectors';
import { selectExclusiveContent } from '@debbie/cortex/dist/exclusiveContent/selectors';
import { selectMe } from '@debbie/cortex/dist/me/selectors';
const UpdateTimeTracker = (props) => {
    const singleCase = useSelector((s) => selectCaseById(s, props.id));
    const caseUpdates = useSelector((s) => singleCase && selectCaseUpdates(s, singleCase.caseId));
    const exclusiveContent = useSelector(selectExclusiveContent);
    const me = useSelector(selectMe);
    const update = caseUpdates &&
        caseUpdates
            .sort((a, b) => {
            // returns newest first
            if (moment(a.pausedAt) > moment(b.pausedAt)) {
                return -1;
            }
            else if (moment(a.pausedAt) < moment(b.pausedAt)) {
                return 1;
            }
            return 0;
        })
            .find((u) => u.updateTypeId === props.updateTypeId);
    useEffect(() => {
        if (update) {
            const startTime = moment();
            return () => {
                if (update) {
                    const endTime = moment();
                    const diffMS = endTime.toDate().getTime() - startTime.toDate().getTime();
                    // Has to be more than 1 second to be considered a real time tracking
                    if (diffMS > 1000) {
                        updatesAPI.addTimeTrackingEntry(update.updateId, startTime.format(), endTime.format());
                        if (exclusiveContent && me && exclusiveContent.includes(me.id)) {
                            notifications.notification({
                                title: `Time tracking ${moment
                                    .duration(endTime.diff(endTime))
                                    .humanize()} on update (${Math.round(diffMS / 1000)} seconds).`,
                            });
                        }
                    }
                }
            };
        }
    }, [props.id, update]);
    return null;
};
export default UpdateTimeTracker;
//# sourceMappingURL=UpdateTimeTracker.js.map